
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34489',
  depVersions: {
  "documents-public-ui": "static-1.34489",
  "atom": "static-1.5066",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2493",
  "client-types": "static-1.466",
  "cssUtils": "static-1.790",
  "customer-data-filters-ui": "static-1.39732",
  "customer-data-objects": "static-1.7661",
  "customer-data-property-utils": "static-1.8083",
  "documents-lib": "static-1.34494",
  "emoji-mart": "static-3.4",
  "FormsCommonComponents": "static-1.85823",
  "FormUrlGenerator": "static-2.4712",
  "foundations-theming-specialty": "static-1.2128",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4994",
  "highcharts": "static-8.103",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5588",
  "hs-test-utils": "static-1.8008",
  "hub-http": "static-1.6218",
  "hubspot-dlb": "static-2.1845",
  "HubStyleTokens": "static-2.11464",
  "I18n": "static-7.1624",
  "jasmine-immutable": "static-1.3016",
  "jasmine-runner": "static-1.6461",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7152",
  "lodash": "static-1.3",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "property-translator": "static-1.5394",
  "quartz": "static-1.7024",
  "react": "static-7.185",
  "react-dlb": "static-1.78",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.71",
  "react-rhumb": "static-1.16664",
  "react-utils": "static-2.5339",
  "react-virtualized": "static-2.98",
  "reference-resolvers": "static-1.8164",
  "reference-resolvers-lite": "static-1.8088",
  "reporting-data": "static-1.67512",
  "reporting-reports": "static-1.67190",
  "reporting-snowflake": "static-1.56130",
  "reporting-testing-lib": "static-1.9445",
  "reporting-visualizations": "static-1.59588",
  "reselect": "static-2.16",
  "sales-content-partitioning": "static-1.8937",
  "sanitize": "static-1.4471",
  "sanitize-text": "static-1.8136",
  "self-service-api": "static-1.10243",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1743",
  "signup-constants": "static-1.18823",
  "signup-ui-url-generator": "static-2.8041",
  "StyleGuideUI": "static-3.487",
  "superstore": "static-1.4757",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4759",
  "ui-addon-form-validation": "static-1.10987",
  "ui-asset-management-lib": "static-1.11017",
  "ui-images": "static-2.1153",
  "usage-tracker": "static-1.7338",
  "usage-tracker-container": "static-1.7328",
  "usage-tracker-core": "static-1.7188",
  "viral-links-lib": "static-1.7056",
  "webpack-env": "static-1.54",
  "data-fetching-client": "static-1.9665",
  "flux-actions": "static-1.337",
  "foundations-components": "static-1.7924",
  "HubStyle": "static-2.11771",
  "icons": "static-2.646",
  "immutable": "static-2.79",
  "isMobile": "static-1.7",
  "PortalIdParser": "static-2.397",
  "quartz-config": "static-1.802",
  "quartz-core": "static-1.6243",
  "quick-fetch": "static-1.3912",
  "raven": "static-3.5907",
  "react-select-plus": "static-1.104",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reporting-ui-components": "static-2.64783",
  "rpc-client-utils": "static-1.4645",
  "transmute": "static-2.85",
  "ui-addon-i18n": "static-1.11145",
  "ui-addon-upgrades": "static-9.17977",
  "UIComponents": "static-3.8410",
  "enviro": "static-4.446",
  "hs-promise-rejection-tracking": "static-1.5566",
  "raven-hubspot": "static-1.6214",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "hubspot-url-utils": "static-1.4115",
  "metrics-js": "static-1.9619",
  "styled-components": "static-2.89",
  "bend-plugin-trellis-migration": "static-1.3395",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3301",
  "quartz-webpack": "static-1.3248",
  "foundations-assets": "static-1.4859",
  "foundations-theming": "static-1.4412",
  "hub-http-shared-msw-handlers": "static-1.9941",
  "hubspotter-http": "static-1.4647",
  "sassPrefix": "static-1.155",
  "events-data-lib": "static-1.212",
  "conversations-skeleton-state": "static-1.7241",
  "crm-message-bus": "static-1.42965",
  "customer-data-filters-ui-msw-helpers": "static-1.22167",
  "customer-data-objects-ui-components": "static-1.13020",
  "customer-data-reference-ui-components": "static-1.13156",
  "customer-data-ui-utilities": "static-1.9820",
  "framework-builder-read-service-client": "static-1.4000",
  "framework-data-schema-quick-fetch": "static-1.6783",
  "framework-data-schema-resolvers": "static-1.6878",
  "inbound-db-meta-service-client": "static-1.3580",
  "inbound-db-properties-service-client": "static-1.3841",
  "multi-account-reference-resolvers": "static-1.974",
  "onboarding-tours": "static-1.16582",
  "reporting-datasets-permissions-lib": "static-1.13658",
  "ui-addon-teams": "static-1.21537",
  "quartz-auth": "static-1.699",
  "ui-business-units-lib": "static-1.9045",
  "usage-tracker-session-replay": "static-1.5024",
  "ai-components-ui-library": "static-1.8949",
  "ContentUtils": "static-1.68340",
  "customer-data-properties": "static-1.51516",
  "forms-ai-lib": "static-1.4310",
  "forms-utils-lib": "static-1.12568",
  "foundations-components-test-utils": "static-1.5407",
  "react-dnd-compat": "static-1.4611",
  "react-tinymce": "static-1.55218",
  "tinymce-config": "static-2.54344",
  "ui-gdpr-components": "static-1.10343",
  "underscore": "static-1.8",
  "foundations-theming-base": "static-1.3397",
  "HeadJS": "static-2.760",
  "framer-motion": "static-1.71",
  "hs-test-utils-bend-plugin": "static-1.3119",
  "msw": "static-1.39",
  "testing-library": "static-1.151",
  "hs-locale-management": "static-1.76",
  "i18n-data": "static-1.221",
  "moment-timezone": "static-5.82",
  "jasmine": "static-4.4322",
  "csstype": "static-1.50",
  "quartz-head": "static-1.689",
  "web-vitals": "static-1.4",
  "batch-promise": "static-1.1535",
  "external-options-client-types": "static-1.4153",
  "fast-json-stable-stringify": "static-1.4",
  "quartz-i18n": "static-1.699",
  "frontend-preferences-client": "static-1.7924",
  "graphql": "static-1.81",
  "immer": "static-1.33",
  "persist-promise": "static-1.3692",
  "reporting-client-types": "static-1.2499",
  "apollo-stack-hubspot": "static-3.85",
  "growth-payments-core": "static-1.25356",
  "hubspot-apollo-client": "static-1.4873",
  "foundations-components-legacy": "static-1.949",
  "merchandise-lib": "static-1.263",
  "quartz-routing": "static-1.454",
  "hs-story-utils": "static-1.9421",
  "react-flip-move": "static-1.69",
  "nested-table": "static-1.221",
  "timezone-utils": "static-2.5238",
  "bend-plugin-foundations-components": "static-1.4193",
  "floating-ui": "static-1.55",
  "react-aria": "static-1.65",
  "react-create-root-preference": "static-1.22",
  "tanstack-table": "static-1.54",
  "trellis-assets": "static-1.1911",
  "ui-fonts": "static-1.726",
  "dispatcher": "static-1.136",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.833",
  "mobile-manifest-mixins": "static-1.534",
  "module-federation": "static-1.22",
  "quartz-test": "static-1.699",
  "quartz-tracking": "static-1.403",
  "reporting-action-components": "static-1.41284",
  "reporting-plugins": "static-1.10312",
  "bend-plugin-chirp-manifest": "static-1.55",
  "chirp-fetch": "static-1.1882",
  "purchase-motions-components": "static-1.5878",
  "salesImages": "static-1.525",
  "ts-schema": "static-1.4075",
  "bender-build-tools": "static-1.3199",
  "bend-plugin-foundations-theming": "static-1.2895",
  "stylex": "static-1.32",
  "hs-resources": "static-1.148",
  "pulse": "static-1.570",
  "restore-request-side-panel-lib": "static-1.871",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3792",
  "crm-pipelines-api-client-types": "static-1.4133",
  "multi-currency-client-types": "static-1.3686",
  "getting-started-shared-tasks": "static-1.18465",
  "growth-data-modal": "static-1.5419",
  "growth-onboarding-confetti": "static-1.3061",
  "growth-onboarding-next-action-utils": "static-1.1894",
  "navigation-components": "static-1.18010",
  "onboarding-tours-client": "static-1.4796",
  "onboarding-tours-utils": "static-1.648",
  "ui-shepherd-react": "static-3.10156",
  "ui-shepherd-tracker": "static-1.7537",
  "ui-universal-auth": "static-1.8969",
  "user-context": "static-1.5098",
  "hubspotter-http-shared-msw-handlers": "static-1.9939",
  "amplitude-session-replay-browser": "static-1.59",
  "chatspot-core": "static-1.21258",
  "copilot-toolkit": "static-1.11116",
  "cms-field-types": "static-1.4805",
  "content-icons-ui": "static-1.2225",
  "integrations-lib": "static-1.16094",
  "calling-global-api": "static-1.64488",
  "calling-internal-common": "static-1.31296",
  "calling-lifecycle-internal": "static-1.65870",
  "calling-lifecycle-messages": "static-1.58164",
  "commerce-products-lib": "static-1.9520",
  "crm-links": "static-1.6285",
  "customer-data-properties-shared-msw-handlers": "static-1.9268",
  "file-manager-components": "static-1.23603",
  "google-libphonenumber": "static-1.37",
  "inbounddb-objects-service-types": "static-1.4218",
  "meetings-icalendar-utils-lib": "static-1.625",
  "object-builder-ui-client": "static-1.48717",
  "pipeline-validation-client-types": "static-1.3960",
  "property-value-citations": "static-1.2130",
  "smart-property-lib": "static-1.6946",
  "tiered-pricing": "static-1.1200",
  "zustand": "static-1.74",
  "ui-addon-iframeable": "static-1.9051",
  "final-form": "static-1.69",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19822",
  "tinymce-themes": "static-1.56314",
  "data-token-picker": "static-1.16399",
  "hub-http-contrib": "static-1.3037",
  "interframe": "static-3.4754",
  "tinymce-data": "static-1.40429",
  "tinymce-plugins": "static-1.57458",
  "ui-addon-sales-email": "static-1.5206",
  "onboarding-scopes": "static-1.6456",
  "ui-addon-opt": "static-4.8363",
  "apollo-link-hub-http": "static-2.4644",
  "hubspot-apollo-cache": "static-1.332",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.167",
  "content-assistance-lib": "static-1.7742",
  "dashboard-lib": "static-1.81506",
  "ExportDialog": "static-6.10385",
  "hubspot-prosemirror": "static-1.18219",
  "hubspot-prosemirror-plugins": "static-1.18211",
  "prosemirror": "static-1.13",
  "react-colorpicker": "static-2.10203",
  "share-with-third-party-component-lib": "static-1.8698",
  "campaign-roi-lib": "static-1.9087",
  "purchase-motions-api": "static-1.5881",
  "trials-service-types": "static-1.3898",
  "bend-plugin-pulse": "static-1.73",
  "directed-graph": "static-1.929",
  "event-emitter": "static-1.942",
  "fast-json-patch": "static-1.62",
  "onboarding-data-sync-lib": "static-1.1947",
  "growth-onboarding-next-action-components": "static-1.1922",
  "user-context-client": "static-1.4606",
  "idb-keyval": "static-1.43",
  "magpie-lib": "static-1.5548",
  "magpie-types": "static-1.5008",
  "nest": "static-1.220",
  "reactive-lib": "static-1.718",
  "simple-logging-lib": "static-1.3043",
  "unified-auth-core-lib": "static-1.765",
  "getting-started-shared-tasks-store": "static-1.17583",
  "markdown-it": "static-1.6",
  "integrations-error-boundary-lib": "static-1.13509",
  "integrations-tracking-lib": "static-1.5594",
  "native-integrations-shared-strings": "static-1.7777",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10362",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.483",
  "calling-error-reporting": "static-1.31303",
  "shared-worker-versioning": "static-1.11031",
  "calling-usage-tracker": "static-1.6535",
  "voice-sms-access-library": "static-1.951",
  "customer-data-tracking": "static-1.6882",
  "commerce-permissions": "static-1.763",
  "products-iframe-lib": "static-1.7909",
  "products-ui-components-shared-msw-handlers": "static-1.10323",
  "location-customization-utils-lib": "static-1.9230",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4149",
  "video-components-external": "static-1.11239",
  "video-data-lib": "static-1.34897",
  "data-agent-kit": "static-1.184",
  "feedback-loader": "static-1.29285",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10024",
  "fsm": "static-1.3726",
  "policy-lib": "static-1.6774",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.10087",
  "navigation-messaging": "static-1.7337",
  "FileManagerLib": "static-1.39243",
  "NamespacedHubStyle": "static-2.9054",
  "FileManagerCore": "static-1.39102",
  "codemirror": "static-5.94",
  "layout-dnd-components": "static-1.12437",
  "layout-dnd-utils": "static-1.11412",
  "react-codemirror": "static-1.10621",
  "ui-addon-emoji-picker": "static-1.9883",
  "ui-brand-identity-lib": "static-1.15249",
  "ui-addon-video-player": "static-1.8697",
  "ui-coaching-tips": "static-1.28531",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8483",
  "payment-link-components": "static-1.23510",
  "EmailSignatureEditor": "static-1.24352",
  "breeze-engine-lib": "static-1.605",
  "InboxConnectUtils": "static-4.14789",
  "universal-page-editor-lib": "static-1.3008",
  "google-sheets-integration-lib": "static-1.213",
  "microsoft-drive-integration-lib": "static-1.333",
  "calling-orchestration-schema": "static-1.35728",
  "sales-views-client-types": "static-1.4253",
  "crm-record-cards-service-types": "static-1.3592",
  "content-media-composition-data-lib": "static-1.12235",
  "content-media-compositions": "static-2.16242",
  "media-bridge-lib": "static-1.18916",
  "trellis-story-utils": "static-1.4511",
  "storybook-react": "static-1.32",
  "audio-components": "static-1.5906",
  "FileManagerImages": "static-1.36754",
  "video-components": "static-1.13242",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4531",
  "video-embed": "static-1.35731",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68415",
  "layout-data-lib": "static-1.9737",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6575",
  "commerce-tours-lib": "static-1.6080",
  "growth-onboarding-reliability": "static-1.5076",
  "sales-checkout-service-client": "static-1.3635",
  "draft-convert": "static-2.72",
  "draft-extend": "static-3.74",
  "draft-js": "static-5.77",
  "draft-plugins": "static-2.21666",
  "sales-email-signature-service-client": "static-1.3837",
  "ably": "static-2.2",
  "social-insights-client-types": "static-1.22075",
  "outpost": "static-1.4177",
  "advanced-menus-core": "static-1.15117",
  "advanced-menus-lib": "static-1.12060",
  "ui-memberships-settings-lib": "static-1.34024",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15116",
  "simple-menus-lib": "static-1.16633"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34489",
  "atom": "/atom/static-1.5066",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2493",
  "client-types": "/client-types/static-1.466",
  "cssUtils": "/cssUtils/static-1.790",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39732",
  "customer-data-objects": "/customer-data-objects/static-1.7661",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8083",
  "documents-lib": "/documents-lib/static-1.34494",
  "emoji-mart": "/emoji-mart/static-3.4",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85823",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4712",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2128",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4994",
  "highcharts": "/highcharts/static-8.103",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5588",
  "hs-test-utils": "/hs-test-utils/static-1.8008",
  "hub-http": "/hub-http/static-1.6218",
  "hubspot-dlb": "/hubspot-dlb/static-2.1845",
  "HubStyleTokens": "/HubStyleTokens/static-2.11464",
  "I18n": "/I18n/static-7.1624",
  "jasmine-immutable": "/jasmine-immutable/static-1.3016",
  "jasmine-runner": "/jasmine-runner/static-1.6461",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7152",
  "lodash": "/lodash/static-1.3",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "property-translator": "/property-translator/static-1.5394",
  "quartz": "/quartz/static-1.7024",
  "react": "/react/static-7.185",
  "react-dlb": "/react-dlb/static-1.78",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.71",
  "react-rhumb": "/react-rhumb/static-1.16664",
  "react-utils": "/react-utils/static-2.5339",
  "react-virtualized": "/react-virtualized/static-2.98",
  "reference-resolvers": "/reference-resolvers/static-1.8164",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8088",
  "reporting-data": "/reporting-data/static-1.67512",
  "reporting-reports": "/reporting-reports/static-1.67190",
  "reporting-snowflake": "/reporting-snowflake/static-1.56130",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9445",
  "reporting-visualizations": "/reporting-visualizations/static-1.59588",
  "reselect": "/reselect/static-2.16",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8937",
  "sanitize": "/sanitize/static-1.4471",
  "sanitize-text": "/sanitize-text/static-1.8136",
  "self-service-api": "/self-service-api/static-1.10243",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1743",
  "signup-constants": "/signup-constants/static-1.18823",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8041",
  "StyleGuideUI": "/StyleGuideUI/static-3.487",
  "superstore": "/superstore/static-1.4757",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4759",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10987",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11017",
  "ui-images": "/ui-images/static-2.1153",
  "usage-tracker": "/usage-tracker/static-1.7338",
  "usage-tracker-container": "/usage-tracker-container/static-1.7328",
  "usage-tracker-core": "/usage-tracker-core/static-1.7188",
  "viral-links-lib": "/viral-links-lib/static-1.7056",
  "webpack-env": "/webpack-env/static-1.54",
  "data-fetching-client": "/data-fetching-client/static-1.9665",
  "flux-actions": "/flux-actions/static-1.337",
  "foundations-components": "/foundations-components/static-1.7924",
  "HubStyle": "/HubStyle/static-2.11771",
  "icons": "/icons/static-2.646",
  "immutable": "/immutable/static-2.79",
  "isMobile": "/isMobile/static-1.7",
  "PortalIdParser": "/PortalIdParser/static-2.397",
  "quartz-config": "/quartz-config/static-1.802",
  "quartz-core": "/quartz-core/static-1.6243",
  "quick-fetch": "/quick-fetch/static-1.3912",
  "raven": "/raven/static-3.5907",
  "react-select-plus": "/react-select-plus/static-1.104",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reporting-ui-components": "/reporting-ui-components/static-2.64783",
  "rpc-client-utils": "/rpc-client-utils/static-1.4645",
  "transmute": "/transmute/static-2.85",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11145",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17977",
  "UIComponents": "/UIComponents/static-3.8410",
  "enviro": "/enviro/static-4.446",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5566",
  "raven-hubspot": "/raven-hubspot/static-1.6214",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4115",
  "metrics-js": "/metrics-js/static-1.9619",
  "styled-components": "/styled-components/static-2.89",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3395",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3301",
  "quartz-webpack": "/quartz-webpack/static-1.3248",
  "foundations-assets": "/foundations-assets/static-1.4859",
  "foundations-theming": "/foundations-theming/static-1.4412",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9941",
  "hubspotter-http": "/hubspotter-http/static-1.4647",
  "sassPrefix": "/sassPrefix/static-1.155",
  "events-data-lib": "/events-data-lib/static-1.212",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7241",
  "crm-message-bus": "/crm-message-bus/static-1.42965",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.22167",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13020",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13156",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9820",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4000",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6783",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6878",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3580",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3841",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.974",
  "onboarding-tours": "/onboarding-tours/static-1.16582",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13658",
  "ui-addon-teams": "/ui-addon-teams/static-1.21537",
  "quartz-auth": "/quartz-auth/static-1.699",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9045",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5024",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8949",
  "ContentUtils": "/ContentUtils/static-1.68340",
  "customer-data-properties": "/customer-data-properties/static-1.51516",
  "forms-ai-lib": "/forms-ai-lib/static-1.4310",
  "forms-utils-lib": "/forms-utils-lib/static-1.12568",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5407",
  "react-dnd-compat": "/react-dnd-compat/static-1.4611",
  "react-tinymce": "/react-tinymce/static-1.55218",
  "tinymce-config": "/tinymce-config/static-2.54344",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10343",
  "underscore": "/underscore/static-1.8",
  "foundations-theming-base": "/foundations-theming-base/static-1.3397",
  "HeadJS": "/HeadJS/static-2.760",
  "framer-motion": "/framer-motion/static-1.71",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3119",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.151",
  "hs-locale-management": "/hs-locale-management/static-1.76",
  "i18n-data": "/i18n-data/static-1.221",
  "moment-timezone": "/moment-timezone/static-5.82",
  "jasmine": "/jasmine/static-4.4322",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.689",
  "web-vitals": "/web-vitals/static-1.4",
  "batch-promise": "/batch-promise/static-1.1535",
  "external-options-client-types": "/external-options-client-types/static-1.4153",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "quartz-i18n": "/quartz-i18n/static-1.699",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7924",
  "graphql": "/graphql/static-1.81",
  "immer": "/immer/static-1.33",
  "persist-promise": "/persist-promise/static-1.3692",
  "reporting-client-types": "/reporting-client-types/static-1.2499",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.85",
  "growth-payments-core": "/growth-payments-core/static-1.25356",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4873",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.949",
  "merchandise-lib": "/merchandise-lib/static-1.263",
  "quartz-routing": "/quartz-routing/static-1.454",
  "hs-story-utils": "/hs-story-utils/static-1.9421",
  "react-flip-move": "/react-flip-move/static-1.69",
  "nested-table": "/nested-table/static-1.221",
  "timezone-utils": "/timezone-utils/static-2.5238",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4193",
  "floating-ui": "/floating-ui/static-1.55",
  "react-aria": "/react-aria/static-1.65",
  "react-create-root-preference": "/react-create-root-preference/static-1.22",
  "tanstack-table": "/tanstack-table/static-1.54",
  "trellis-assets": "/trellis-assets/static-1.1911",
  "ui-fonts": "/ui-fonts/static-1.726",
  "dispatcher": "/dispatcher/static-1.136",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.833",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.534",
  "module-federation": "/module-federation/static-1.22",
  "quartz-test": "/quartz-test/static-1.699",
  "quartz-tracking": "/quartz-tracking/static-1.403",
  "reporting-action-components": "/reporting-action-components/static-1.41284",
  "reporting-plugins": "/reporting-plugins/static-1.10312",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.55",
  "chirp-fetch": "/chirp-fetch/static-1.1882",
  "purchase-motions-components": "/purchase-motions-components/static-1.5878",
  "salesImages": "/salesImages/static-1.525",
  "ts-schema": "/ts-schema/static-1.4075",
  "bender-build-tools": "/bender-build-tools/static-1.3199",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2895",
  "stylex": "/stylex/static-1.32",
  "hs-resources": "/hs-resources/static-1.148",
  "pulse": "/pulse/static-1.570",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.871",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3792",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4133",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3686",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18465",
  "growth-data-modal": "/growth-data-modal/static-1.5419",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3061",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1894",
  "navigation-components": "/navigation-components/static-1.18010",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4796",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.648",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10156",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7537",
  "ui-universal-auth": "/ui-universal-auth/static-1.8969",
  "user-context": "/user-context/static-1.5098",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9939",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.59",
  "chatspot-core": "/chatspot-core/static-1.21258",
  "copilot-toolkit": "/copilot-toolkit/static-1.11116",
  "cms-field-types": "/cms-field-types/static-1.4805",
  "content-icons-ui": "/content-icons-ui/static-1.2225",
  "integrations-lib": "/integrations-lib/static-1.16094",
  "calling-global-api": "/calling-global-api/static-1.64488",
  "calling-internal-common": "/calling-internal-common/static-1.31296",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65870",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.58164",
  "commerce-products-lib": "/commerce-products-lib/static-1.9520",
  "crm-links": "/crm-links/static-1.6285",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9268",
  "file-manager-components": "/file-manager-components/static-1.23603",
  "google-libphonenumber": "/google-libphonenumber/static-1.37",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4218",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.625",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48717",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3960",
  "property-value-citations": "/property-value-citations/static-1.2130",
  "smart-property-lib": "/smart-property-lib/static-1.6946",
  "tiered-pricing": "/tiered-pricing/static-1.1200",
  "zustand": "/zustand/static-1.74",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9051",
  "final-form": "/final-form/static-1.69",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19822",
  "tinymce-themes": "/tinymce-themes/static-1.56314",
  "data-token-picker": "/data-token-picker/static-1.16399",
  "hub-http-contrib": "/hub-http-contrib/static-1.3037",
  "interframe": "/interframe/static-3.4754",
  "tinymce-data": "/tinymce-data/static-1.40429",
  "tinymce-plugins": "/tinymce-plugins/static-1.57458",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5206",
  "onboarding-scopes": "/onboarding-scopes/static-1.6456",
  "ui-addon-opt": "/ui-addon-opt/static-4.8363",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4644",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.332",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.167",
  "content-assistance-lib": "/content-assistance-lib/static-1.7742",
  "dashboard-lib": "/dashboard-lib/static-1.81506",
  "ExportDialog": "/ExportDialog/static-6.10385",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18219",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18211",
  "prosemirror": "/prosemirror/static-1.13",
  "react-colorpicker": "/react-colorpicker/static-2.10203",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8698",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.9087",
  "purchase-motions-api": "/purchase-motions-api/static-1.5881",
  "trials-service-types": "/trials-service-types/static-1.3898",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.73",
  "directed-graph": "/directed-graph/static-1.929",
  "event-emitter": "/event-emitter/static-1.942",
  "fast-json-patch": "/fast-json-patch/static-1.62",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1947",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1922",
  "user-context-client": "/user-context-client/static-1.4606",
  "idb-keyval": "/idb-keyval/static-1.43",
  "magpie-lib": "/magpie-lib/static-1.5548",
  "magpie-types": "/magpie-types/static-1.5008",
  "nest": "/nest/static-1.220",
  "reactive-lib": "/reactive-lib/static-1.718",
  "simple-logging-lib": "/simple-logging-lib/static-1.3043",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.765",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17583",
  "markdown-it": "/markdown-it/static-1.6",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13509",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5594",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7777",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10362",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.483",
  "calling-error-reporting": "/calling-error-reporting/static-1.31303",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11031",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6535",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.951",
  "customer-data-tracking": "/customer-data-tracking/static-1.6882",
  "commerce-permissions": "/commerce-permissions/static-1.763",
  "products-iframe-lib": "/products-iframe-lib/static-1.7909",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10323",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9230",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4149",
  "video-components-external": "/video-components-external/static-1.11239",
  "video-data-lib": "/video-data-lib/static-1.34897",
  "data-agent-kit": "/data-agent-kit/static-1.184",
  "feedback-loader": "/feedback-loader/static-1.29285",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10024",
  "fsm": "/fsm/static-1.3726",
  "policy-lib": "/policy-lib/static-1.6774",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.10087",
  "navigation-messaging": "/navigation-messaging/static-1.7337",
  "FileManagerLib": "/FileManagerLib/static-1.39243",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9054",
  "FileManagerCore": "/FileManagerCore/static-1.39102",
  "codemirror": "/codemirror/static-5.94",
  "layout-dnd-components": "/layout-dnd-components/static-1.12437",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11412",
  "react-codemirror": "/react-codemirror/static-1.10621",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9883",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.15249",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8697",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28531",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8483",
  "payment-link-components": "/payment-link-components/static-1.23510",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24352",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.605",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14789",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3008",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.213",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.333",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35728",
  "sales-views-client-types": "/sales-views-client-types/static-1.4253",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3592",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12235",
  "content-media-compositions": "/content-media-compositions/static-2.16242",
  "media-bridge-lib": "/media-bridge-lib/static-1.18916",
  "trellis-story-utils": "/trellis-story-utils/static-1.4511",
  "storybook-react": "/storybook-react/static-1.32",
  "audio-components": "/audio-components/static-1.5906",
  "FileManagerImages": "/FileManagerImages/static-1.36754",
  "video-components": "/video-components/static-1.13242",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4531",
  "video-embed": "/video-embed/static-1.35731",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68415",
  "layout-data-lib": "/layout-data-lib/static-1.9737",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6575",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6080",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5076",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3635",
  "draft-convert": "/draft-convert/static-2.72",
  "draft-extend": "/draft-extend/static-3.74",
  "draft-js": "/draft-js/static-5.77",
  "draft-plugins": "/draft-plugins/static-2.21666",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3837",
  "ably": "/ably/static-2.2",
  "social-insights-client-types": "/social-insights-client-types/static-1.22075",
  "outpost": "/outpost/static-1.4177",
  "advanced-menus-core": "/advanced-menus-core/static-1.15117",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12060",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34024",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15116",
  "simple-menus-lib": "/simple-menus-lib/static-1.16633"
}
};
